import { MySvgIcon, MySvgIconProps } from './MySvgIcon'

type IconEllipsisProps = MySvgIconProps & {
  className?: string
  focusable?: boolean
  title?: string
}

export const IconEllipsis = ({ ...props }: IconEllipsisProps) => (
  <MySvgIcon
    width="21px"
    height="21px"
    viewBox="0 0 448 512"
    version="1.1"
    title="Cog"
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M120 256c0 30.9-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56s56 25.1 56 56zm160 0c0 30.9-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56s56 25.1 56 56zm104 56c-30.9 0-56-25.1-56-56s25.1-56 56-56s56 25.1 56 56s-25.1 56-56 56z" />
    </g>
  </MySvgIcon>
)
